import React from 'react';

import PaginatedIndexQuery from '../PaginatedIndexQueryContainer';
import ContestIndexPage from 'buyside/components/presentation/ContestIndexPage/contestIndexPage';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import ContestIndexQuery from 'buyside/graphql/queries/ContestIndexList';

const ContestIndexPageContainer = () => {
  const queryName = 'contestIndex';
  return (
    <PaginatedIndexQuery
      query={ContestIndexQuery}
      queryName={queryName}
      secondaryField="featuredContests"
      pageSize={8}
    >
      {({ loading, data }) => {
        if (loading) return <LoadingSpinner />;
        return <ContestIndexPage data={data} />;
      }}
    </PaginatedIndexQuery>
  );
};

export default ContestIndexPageContainer;
